<template>
  <a class="float-right" 
     href="#" 
     :title="translate('label.modal.title.print')"
     @click.prevent="showPrintDialog">
    <img src="/img/print.svg">
  </a>
</template>

<script>
export default {
  created() {
      EventDispatcher.listen('print', () => {
          window.print();
      });
  },
  methods: {
    showPrintDialog() {
      EventDispatcher.fire('showPrintDialog');
    }
  } 
}
</script>

<style lang="scss">
  a:hover, a:active, a:focus, a:visited {
    text-decoration: none;
    border-bottom: none;
  }
  @media print {
      a.float-right {
          display: none;
      }
  }
</style>